import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FaPhoneAlt,
  FaCreditCard,
  FaCalendarAlt,
  FaLock,
  FaShieldAlt,
  FaHeadset,
} from "react-icons/fa";

const PaymentForm = () => {
  const [selectedMethod, setSelectedMethod] = useState("wallet");

  const formik = useFormik({
    initialValues: {
      phone: "",
      cardNumber: "",
      expiry: "",
      cvv: "",
    },
    validationSchema: Yup.object({
phone:
  selectedMethod === "wallet"
    ? Yup.string()
        .matches(/^01[0-9]{9}$/, "Enter a valid Egyptian phone number")
        .required("Phone number is required")
    : Yup.string(),

      cardNumber:
        selectedMethod === "card"
          ? Yup.string()
              .matches(/^[0-9]{16}$/, "Enter a valid 16-digit card number")
              .required("Card number is required")
          : Yup.string(),
      expiry:
        selectedMethod === "card"
          ? Yup.string()
              .matches(/^(0[1-9]|1[0-2])\/\d{2}$/, "Use MM/YY format")
              .required("Expiry date is required")
          : Yup.string(),
      cvv:
        selectedMethod === "card"
          ? Yup.string()
              .matches(/^[0-9]{3}$/, "Enter a 3-digit CVV")
              .required("CVV is required")
          : Yup.string(),
    }),
    onSubmit: (values) => {
      console.log("Payment Submitted:", values);
      alert("Payment Submitted!");
    },
  });

  return (
    <div className="max-w-3xl mx-auto p-8 bg-zinc-100 shadow-md rounded-xl mt-12">
      <h2 className="text-3xl font-bold mb-8 text-center text-black">
        Complete Your Payment
      </h2>

      <div className="border border-gray-200 p-6 bg-white rounded-lg mb-8 flex items-center justify-between">
        <div>
          <h3 className="text-xl font-semibold text-black">
            Web Development Fundamentals
          </h3>
          <p className="text-sm text-gray-600">Dr. Ahmed Mahmoud</p>
          <p className="text-sm text-gray-500 mt-1">8 weeks</p>
        </div>
        <div className="text-xl font-bold text-black">250 EGP</div>
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className="mb-6 p-4 rounded-xl bg-white"
      >
        <h4 className="text-xl font-medium text-black mb-2">
          Select Payment Method
        </h4>
        <p className="text-sm text-gray-500 mb-4">
          Choose your preferred way to pay
        </p>

        <div className="flex gap-2 mb-6">
          <button
            type="button"
            onClick={() => setSelectedMethod("card")}
            className={`flex-1 px-4 py-2 rounded border text-sm font-medium transition ${
              selectedMethod === "card"
                ? "bg-black text-white border-black"
                : "bg-white text-black border-gray-300"
            }`}
          >
            Bank Card
          </button>
          <button
            type="button"
            onClick={() => setSelectedMethod("wallet")}
            className={`flex-1 px-4 py-2 rounded border text-sm font-medium transition ${
              selectedMethod === "wallet"
                ? "bg-black text-white border-black"
                : "bg-white text-black border-gray-300"
            }`}
          >
            Mobile Wallet
          </button>
          {/* <button
            type="button"
            onClick={() => setSelectedMethod("fawry")}
            className={`flex-1 px-4 py-2 rounded border text-sm font-medium transition ${
              selectedMethod === "fawry"
                ? "bg-black text-white border-black"
                : "bg-white text-black border-gray-300"
            }`}
          >
            Fawry
          </button> */}
        </div>

        {/* Mobile Wallet */}
        {selectedMethod === "wallet" && (
          <div className="mb-6">
            <label className="block text-sm font-medium mb-1 text-black">
              <FaPhoneAlt className="inline mr-1 text-xl mx-1" />
              Phone Number
            </label>
            <input
              type="text"
              name="phone"
              placeholder="01XXXXXXXXX"
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-black"
              value={formik.values.phone}
              onChange={formik.handleChange}
            />
            {formik.errors.phone && formik.touched.phone && (
              <p className="text-red-500 text-xs mt-1">{formik.errors.phone}</p>
            )}
            <p className="text-xs text-gray-500 mt-2">
              Enter the phone number registered with your mobile wallet.
            </p>
            <p className="text-xs text-gray-500 mt-1">
              You will receive a notification on your phone to confirm the
              payment.
            </p>
          </div>
        )}

        {/* Bank Card */}
        {selectedMethod === "card" && (
          <div className="mb-6 space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1 text-black">
                <FaCreditCard className="inline mr-1 text-xl mx-1" />
                Card Number
              </label>
              <input
                type="text"
                name="cardNumber"
                placeholder="1234 5678 9012 3456"
                className="w-full px-4 py-2 border border-gray-300 rounded-md text-black"
                value={formik.values.cardNumber}
                onChange={formik.handleChange}
              />
              {formik.errors.cardNumber && formik.touched.cardNumber && (
                <p className="text-red-500 text-xs mt-1">
                  {formik.errors.cardNumber}
                </p>
              )}
            </div>
            <div className="flex gap-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1 text-black">
                  <FaCalendarAlt className="inline mr-1 text-xl mx-1" />
                  Expiry Date
                </label>
                <input
                  type="text"
                  name="expiry"
                  placeholder="MM/YY"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md text-black"
                  value={formik.values.expiry}
                  onChange={formik.handleChange}
                />
                {formik.errors.expiry && formik.touched.expiry && (
                  <p className="text-red-500 text-xs mt-1">
                    {formik.errors.expiry}
                  </p>
                )}
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium mb-1 text-black">
                  <FaLock className="inline mr-1 text-xl mx-1" />
                  CVV
                </label>
                <input
                  type="text"
                  name="cvv"
                  placeholder="123"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md text-black"
                  value={formik.values.cvv}
                  onChange={formik.handleChange}
                />
                {formik.errors.cvv && formik.touched.cvv && (
                  <p className="text-red-500 text-xs mt-1">
                    {formik.errors.cvv}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Fawry */}
        {/* {selectedMethod === "fawry" && (
          <div className="mb-6">
            <label className="block text-sm font-medium mb-1 text-black">
              <FaPhoneAlt className="inline mr-1 text-xl mx-1" /> Phone Number
            </label>
            <input
              type="text"
              placeholder="01XXXXXXXXX"
              className="w-full px-4 py-2 border border-gray-300 rounded-md text-black"
            />
            <p className="text-xs text-gray-500 mt-2">
              You will receive a reference number to pay at any Fawry store.
            </p>
          </div>
        )} */}

        <button
          type="submit"
          className="w-full bg-black text-white py-3 rounded-md font-medium hover:bg-gray-800 transition"
        >
          Complete Payment
        </button>
      </form>

      <div className="text-center text-xs text-gray-500 mt-6 flex justify-center gap-6">
        <span className="flex items-center gap-1">
          <FaShieldAlt className="text-xl mx-1" /> Secure Payment
        </span>
        <span className="flex items-center gap-1">
          <FaHeadset className="text-xl mx-1" /> 24/7 Support
        </span>
      </div>
    </div>
  );
};

export default PaymentForm;



